import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { HttpService } from 'app/shared/services/http.service';
import { DblinkedSessionService } from 'app/shared/services/dblinked-session.service';
import { TitleService } from 'app/shared/services/title.service';
import { Message, MessageService } from 'primeng/api';
import { ToolbarService } from 'app/shared/services/toolbar.service';
import { SessionService } from 'app/shared/services/session.service';

@Component({
  selector: 'app-implantacao',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss']
})
export class UploadImplantacaoComponent implements OnInit, OnDestroy {
  @ViewChild('file') fileInput: ElementRef;

  file: File;
  replace: boolean;

  msgs: Message[] = null;

  constructor(private titleService: TitleService,
              private httpService: HttpService,
              private toolbarService: ToolbarService,
              private dblinkedSessionService: DblinkedSessionService,
              private sessionService: SessionService,
              private messageService: MessageService) {
  }

  ngOnInit(): void {
    this.titleService.title = 'Importar planilha';
    Promise.resolve(null).then(() => this.toolbarService.hidden = true);
    // this.toolbarService.clear();
  }

  ngOnDestroy() {
    this.toolbarService.hidden = false;
    // this.toolbarService.clear();
  }

  fileChange() {
    this.file = this.fileInput.nativeElement.files[0];
  }

  importar() {
    const data: FormData = new FormData();
    data.append('file', this.file);
    data.append('type', 'implantacao-txt');
    data.append('usuarioId', this.sessionService.loggedUser.id.toString());

    this.httpService.wait();
    this.httpService.post('/custom/upload', data)
                    .subscribe(result => this.uploaded(result),
                               error => this.httpService.handleError(error, () => this.importar()),
                               () => this.httpService.done());
  }

  private uploaded(res?: any) {



    if (res.result[0].error === true) {
      res.result[0].value.forEach(element => {
        this.messageService.add({ severity: 'warn',key: 'messageLinnks', summary: 'Advertência', detail: element});
      });
    } else {
      this.messageService.add({ severity: 'success',key: 'messageLinnks', summary: 'Sucesso', detail: 'Implantação Realizada com Sucesso!'});
    }

  }

  get importDisabled(): boolean {
    return !this.dblinkedSessionService.hasEmpresaSelected || !this.file;
  }

  hideMessage() {
    this.file = null;

  }
}
